import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_DEVICE](state, payload) {
    let device = payload;

    if (payload.allow !== undefined) {
      device.notification_types = payload.allow
        ? device.notification_types.push(payload.notification_types[0])
        : device.notification_types.filter((nt) => nt !== payload.notification_types[0]);
    }

    state.device = device;
  },
};
